import React, { useState } from "react";
import {
	Modal,
	Paper,
	Typography,
	TextField,
	Button,
	Box,
} from "@mui/material";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CloseIcon from "@mui/icons-material/Close";

const NewFolderModal = ({ open, onClose, onSubmit }) => {
	const [folderName, setFolderName] = useState("");
	// const [error, setError] = useState("");
	const [files, setFiles] = useState([]);

	const createPdfPlaceholder = () => {
		// Simple PDF structure in binary format
		const pdfContent =
			"%PDF-1.4\n1 0 obj<</Type/Catalog/Pages 2 0 R>>endobj\n2 0 obj<</Type/Pages/Count 1/Kids[3 0 R]>>endobj\n3 0 obj<</Type/Page/MediaBox[0 0 612 792]/Parent 2 0 R/Resources<<>>>>endobj\nxref\n0 4\n0000000000 65535 f\n0000000010 00000 n\n0000000053 00000 n\n0000000102 00000 n\ntrailer<</Size 4/Root 1 0 R>>\nstartxref\n178\n%%EOF";

		return new File([pdfContent], "black_sample_file.pdf", {
			type: "application/pdf",
		});
	};

	const handleClose = () => {
		setFiles("");
		setFolderName("");
		onClose();
	};

	const capitalizeWords = (str) => {
		return str.replace(/\b\w/g, (char) => char.toUpperCase());
	};

	const handleSubmit = () => {
		if (!folderName.trim()) {
			// setError("Folder name is required");
			return;
		}

		const capitalizedFolderName = capitalizeWords(folderName.trim());
		const formData = new FormData();

		if (files.length) {
			files.forEach((file) => {
				formData.append("files", file);
			});
		} else {
			// Create a tiny placeholder file
			const placeholderFile = createPdfPlaceholder(); // or createDocPlaceholder();
			formData.append("files", placeholderFile);
		}

		formData.append("folderPath", `Folders/${capitalizedFolderName}`);

		onSubmit(formData);
		handleClose();
	};

	const handleFileSelect = (event) => {
		if (event.target.files) {
			setFiles(Array.from(event.target.files));
		}
	};
	return (
		<Modal open={open} onClose={handleClose}>
			<Paper
				sx={{
					width: "50%",
					padding: 3,
					margin: "auto",
					marginTop: "6%",
					outline: "none",
					overflowY: "auto",
					maxHeight: "700px",
				}}>
				<Typography variant='h6' fontWeight='800'>
					New Folder
				</Typography>
				<TextField
					fullWidth
					label='Folder Name'
					variant='outlined'
					value={folderName}
					onChange={(e) => setFolderName(e.target.value)}
					sx={{ marginTop: 2 }}
				/>

				{/* File Upload Section */}
				<Box
					sx={{
						textAlign: "center",
						marginTop: 3,
						padding: 2,
						backgroundColor: "#F4F6FF",
						borderRadius: 2,
						border: "1px dotted grey",
						height: "293px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
					}}>
					<label htmlFor='file-upload' style={{ cursor: "pointer" }}>
						<CloudUploadRoundedIcon
							sx={{ fontSize: "100px", color: "#000" }}
						/>
					</label>

					<Typography variant='h6' fontWeight='bold'>
						Drop or select file
					</Typography>

					<Typography variant='subtitle1' color='textSecondary'>
						Drop files here or click to{" "}
						<label
							htmlFor='file-upload'
							style={{
								color: "blue",
								cursor: "pointer",
								textDecoration: "underline",
							}}>
							browse
						</label>{" "}
						through your desktop
					</Typography>
					<input
						type='file'
						style={{ display: "none" }}
						id='file-upload'
						multiple
						hidden
						onChange={handleFileSelect}
					/>
				</Box>
				{files.length > 0 &&
					files.map((file, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								alignItems: "center",
								padding: "1rem 2rem",
								borderRadius: "8px",
								border: "1px solid #ddd",
								width: "100%",
								justifyContent: "space-between",
								marginTop: 2,
							}}>
							{/* Left Side - Icon and File Name */}
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: "1.25rem",
								}}>
								<DescriptionRoundedIcon
									sx={{
										color: "#2069F8",
										fontSize: "2.5rem",
									}}
								/>
								<Typography
									variant='body2'
									sx={{
										color: "black",
										textDecoration: "none",
										cursor: "pointer",
										textTransform: "capitalize",
										fontSize: "20px",
									}}>
									{file.name.split(".")[0]}
								</Typography>
								<Typography
									variant='caption'
									sx={{
										color: "gray",
										marginLeft: "20px",
										fontSize: "15px",
									}}>
									{Math.floor(file.size / 1000)} Kb
								</Typography>
							</Box>

							{/* Right Side - File Size & Remove Icon */}
							<Box
								sx={{
									display: "flex",
									alignItems: "flex-end",
									gap: "8px",
									width: "2.5rem",
									height: "2.5rem",
								}}>
								<CloseIcon
									sx={{
										cursor: "pointer",
										color: "gray",
										fontSize: "2rem",
										"&:hover": {
											color: "#FFF",

											background: "#AAAAAA",
											borderRadius: "50%",
										},
									}}
									onClick={() =>
										setFiles(
											files.filter((_, i) => i !== index)
										)
									}
								/>
							</Box>
						</Box>
					))}

				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: 3,
					}}>
					{/* <Button
            variant="contained"
            sx={{ background: "blue" }}
            startIcon={<FileUploadOutlinedIcon />}
          >
            Upload
          </Button> */}
					<Button
						variant='contained'
						onClick={handleSubmit}
						disabled={!folderName.trim()}
						sx={{
							backgroundColor: "#E9EDFE",
							color: "#000",
							"&:hover": {
								backgroundColor: "rgba(216, 191, 216, 0.8)",
							},
							padding: "0.25rem 2rem",
							textTransform: "capitalize",
							boxShadow: "none",
							borderRadius: "8px",
						}}>
						Create
					</Button>
				</Box>
			</Paper>
		</Modal>
	);
};

export default NewFolderModal;
